module.exports = __webpack_public_path__ + "img/bg.e3a47a32.jpg";